import React from 'react'
import Svg, { SvgProps } from 'components/ui/svg'

import * as config from 'styles/tailwind.config'

interface CheckMarkBubbleProps extends SvgProps {
  checked?: boolean
}

class CheckMarkBubble extends Svg<CheckMarkBubbleProps> {
  public render() {
    const { size, checked } = this.props

    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          className="transition duration-150 ease-in-out"
          cx="12.5"
          cy="12.5"
          r="12"
          fill={checked ? config.theme.colors.brand.primary : 'none'}
          stroke={checked ? config.theme.colors.brand.primary : config.theme.colors['gray-200']}
        />
        <path
          className="transition duration-150 ease-in-out"
          d="M6 12.929L10.0489 17L19 8"
          stroke={checked ? config.theme.colors.white : 'none'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export default CheckMarkBubble
